var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"property-details"},[_c('image-gallery',{attrs:{"images":_vm.activeProperty.images}}),_c('div',{staticClass:"content long-description",domProps:{"innerHTML":_vm._s(_vm.sanitizedDescription)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }